<template>
  <article
    class="subscription-upgrade"
    :class="{ '-selected': selected }"
  >
    <details-block :open="false">
      <template #header>
        <h4 class="subscription-upgrade__heading">{{ $t(`upgrades.${upgrade.id}.name`) }}</h4>
      </template>
      <template #default>
        <div class="subscription-upgrade__details">{{ $t(`upgrades.${upgrade.id}.details`) }}</div>
      </template>
    </details-block>
    <template v-if="!subscribed">
      <div class="subscription-upgrade__price">
        {{ upgrade.price }} €
      </div>
      <div class="subscription-upgrade__pricedetails">{{ $t("per.year") }}</div>
    </template>
    <button
      class="button subscription-upgrade__button"
      :class="{ 'button_secondary': buttonSecondary }"
      @click="emit('select')"
    >
      <template v-if="!subscribed">
        <template v-if="selected">
          <lucide-icon name="x" /> <span>{{ $t("actions.remove") }}</span>
        </template>
        <template v-else>
          <lucide-icon name="plus" /> <span>{{ $t("actions.add") }}</span>
        </template>
      </template>
      <template v-else>
        <template v-if="selected">
          <lucide-icon name="plus" /> <span>{{ $t("actions.abortCancel") }}</span>
        </template>
        <template v-else>
          <lucide-icon name="x" /> <span>{{ $t("actions.cancelShort") }}</span>
        </template>
      </template>
    </button>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import DetailsBlock from '@core/ui/DetailsBlock.vue';
import LucideIcon from '@core/ui/LucideIcon.vue';
const { selected, subscribed = false } = defineProps<{
  upgrade: { id: string; price: number },
  selected: boolean,
  mode?: 'order' | 'manage',
  subscribed?: boolean
}>();
const emit = defineEmits<{
  (eventName: 'select'): void
}>();

const buttonSecondary = computed(() => subscribed ? selected : selected);
</script>

<style lang="scss">
.subscription-upgrade {
  display: grid;
  grid-template-rows: 1fr auto auto auto;
  padding: 1.5rem;
  box-shadow: 0 3px 5px var(--color-shadow-2);
  border-radius: 0.25rem;

  &.-selected {
    outline: 2px solid var(--color-primary);
  }

  &__heading {
    font-size: 1.25em;
    margin-top: 0;
    margin-bottom: 0.75rem;
    text-wrap: balance;
    padding-right: 1rem;
  }

  &__details {
    margin-top: 0.25rem;
    margin-bottom: 0.75rem;
  }

  &__price {
    font-size: 1.25em;
    margin-top: 0.5rem;
    font-weight: bold;
  }
  &__pricedetails {
    font-size: 0.9em;
    color: var(--color-text-medium);
  }

  &__button {
    display: flex;
    gap: 0.25rem;
    margin-top: 1rem;
  }
}
</style>